import './Impressum.css';
import Datenschutz from "../Datenschutz.pdf";

export default function Impressum() {
    return (
        <footer className="impressum-container">
            <div className="impressum-content">
                <div className="impressum-section">
                    <h2 className="impressum-title">Impressum</h2>
                </div>

                <div className="impressum-grid">
                    <div className="impressum-block">
                        <h3 className="impressum-subtitle">Verein</h3>
                        <p>
                            DJK Durlach 1924 e. V.<br/>
                            Unten am Grötzinger Weg 1<br/>
                            76227 Karlsruhe
                        </p>
                    </div>

                    <div className="impressum-block">
                        <h3 className="impressum-subtitle">Kontakt</h3>
                        <p>
                            E-Mail Verwaltung: <a href="mailto:mail@djkdurlach.de">mail@djkdurlach.de</a><br></br>
                            E-Mail Vorstand: <a href="mailto:vorstand@djkdurlach.de">vorstand@djkdurlach.de</a>
                        </p>
                    </div>

                    <div className="impressum-block">
                        <h3 className="impressum-subtitle">Vorstand</h3>
                        <p>
                            Maria Rastetter<br/>
                            Mario Altmann<br/>
                            Heinzpeter Fey
                        </p>
                    </div>

                    <div className="impressum-block">
                        <h3 className="impressum-subtitle">Rechtliches</h3>
                        <p>
                            Registergericht: Amtsgericht Mannheim<br/>
                            Registernummer: VR 120113<br/>
                            Datenschutz: <a href={Datenschutz} target="_blank" rel="noreferrer">Datenschutzerklärung</a>
                            <br/>
                            Verantwortlich für den Inhalt:<br/>
                            Matthias Emil Hauswirth
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}